import {FORMAT_ELEMENT_COMMAND, INDENT_CONTENT_COMMAND, LexicalEditor, OUTDENT_CONTENT_COMMAND} from "lexical"
import {AlignType} from "../plugins/toolbar/blocks/align/align"

const debug = false
// const debug = "lexicalAlignText"

export function lexicalAlignText(editor: LexicalEditor, align: AlignType) {
    debug && console.log(debug, 'process')

    switch (align) {
        case AlignType.LEFT     :
        case AlignType.CENTER   :
        case AlignType.RIGHT    :
        case AlignType.JUSTIFY  : editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, align); break

        case AlignType.OUTDENT  : editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined); break
        case AlignType.INDENT   : editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined); break
    }
}